import { CLEAR_STATS, UPDATE_STATS } from "../reducers/actiontypes";

export let clearStats = function() {
	return {
		type: CLEAR_STATS
	};
}

export let updateStats = function(stats) {
	return {
		type: UPDATE_STATS,
		stats: stats
	};
}

export let fetchStats = function() {
	return function(dispatch, getState) {
		var instance = getState().instances.current;

		dispatch(clearStats());

		window.getStats(instance, function(err, data){
			if (!err) {
				dispatch(updateStats(data || {}));
			}
		});
	};
};
